import type { BlokProps } from "@trydig/storyblok";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import { SectionHighlight } from "@/components/ui/sections/SectionHighlight";
import type { SectionHighlightStoryblok } from "@/generated/sb/sb-types";

export const SectionHighlightBlok = ({
  blok,
  preview,
}: BlokProps<SectionHighlightStoryblok>) => {
  return (
    <BlokWrap editable={blok} asChild>
      <SectionHighlight
        items={blok.items}
        fullWidth={blok.fullWidth}
        preview={preview}
      />
    </BlokWrap>
  );
};
